import { Avatar, Divider, Stack, Typography } from '@mui/material';
import { CustomToggleButtons } from 'Components/CustomToggleButtons';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useImposter } from 'Hooks';
import { useIsLawyer } from 'Hooks/useIsLawyer';
import { Cake, NoImageAvatar } from 'Images';
import { getIsLawyerAndUser } from 'Utils/lawyers';

interface IUser {
  lawyersName: string;
}

export const User = ({ lawyersName }: IUser) => {
  const { authenticatedUser, fakeUser } = useImposter();
  const isBirthday = false;

  const isLawyer = useIsLawyer();

  return (
    <>
      <Stack
        sx={{
          gap: '12px',
          alignItems: 'center',
        }}
      >
        <Avatar
          alt=''
          src={NoImageAvatar}
          sx={{ width: '44px', height: '44px' }}
        />
        {isBirthday ? (
          <Stack
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              p: '16px 18px',
              bgcolor: 'purple2.shade_500',
            }}
          >
            <Avatar src={Cake} alt='' />
            <Typography
              variant='body2'
              sx={{
                textAlign: 'center',
                maxWidth: '21ch',
                mt: '9px',
              }}
              overflow='hidden'
              textOverflow='ellipsis'
              whiteSpace='nowrap'
            >
              {isLawyer
                ? lawyersName
                : `${fakeUser.firstName || authenticatedUser.firstName} ${
                    fakeUser.lastName || authenticatedUser.lastName || ''
                  }`}
            </Typography>
            <Typography
              variant='body2'
              sx={{
                textAlign: 'center',
                maxWidth: '21ch',
              }}
            >
              {Dictionary[DICTIONARY.General].sidebar.birthday}
            </Typography>
          </Stack>
        ) : (
          <Typography
            variant='body2'
            overflow='hidden'
            textOverflow='ellipsis'
            whiteSpace='nowrap'
          >
            {isLawyer
              ? lawyersName
              : `${fakeUser.firstName || authenticatedUser.firstName} ${
                  fakeUser.lastName || authenticatedUser.lastName || ''
                }`}
          </Typography>
        )}
      </Stack>
      {getIsLawyerAndUser() && <CustomToggleButtons />}
      {!isBirthday && <Divider aria-hidden='true' orientation='horizontal' />}
    </>
  );
};
